export function facebookPopup(text, url) {
  window.open(`http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${text}`, '', 'toolbar=0, status=0, width=900, height=500');
}

export function twitterPopup(text, url) {
  const fullUrl = `http://${url}`;
  window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}&text=${text}`, '', 'toolbar=0, status=0, width=650, height=360');
}

export function mailToLink({ subject, body }) {
  return `mailto:?subject=${subject}&body=${body}`;
}



// WEBPACK FOOTER //
// ./src/util/share.js